import { DeepLeaf } from '@local/utils'

/**
 * 섬네일 설정 툴: http://photo.navercorp.com/#delivery/view/thumbnail
 * - test 우선 적용 (바로 사용 가능)
 * - 확정 되면 그때 리얼 배포 요청(하루 정도 걸린다고 하니 여유 두고 요청)
 * 1. myplace
 * 3. booking - https://oss.navercorp.com/place/local/issues/2879
 * 4. contact - 회원
 */
export const THUMBNAIL_TYPES = {
  common: {
    w500_60_sharpen: 'w560_sharpen',
    w1500_60_sharpen: 'm1500',
    w560_sharpen: 'w560_sharpen',
    m1500: 'm1500',
  },
  ldb: {
    f80_80_60_sharpen_autoRotate: 'f80_80_60_sharpen_autoRotate',
    f110_110: 'f110_110',
    w500_60_sharpen: 'w500_60_sharpen',
    w1500_60_sharpen: 'w1500_60_sharpen',
  },
  myplace: {
    f120: 'f120',
    f1300_600: 'f1300_600',
    f220_220_70_sharpen: 'f220_220_70_sharpen',
    f352_440: 'f352_440',
    f440_440: 'f440_440',
    f442_442: 'f442_442',
    f442_442_70_sharpen: 'f442_442_70_sharpen',
    f50_blur: 'f50_blur',
    f510_510_70_sharpen: 'f510_510_70_sharpen',
    f660_440: 'f660_440',
    f80_80: 'f80_80',
    f828_466: 'f828_466',
    f828_828: 'f828_828',
    f828_828_70_sharpen: 'f828_828_70_sharpen',
    f912_1140: 'f912_1140',
    f912_608: 'f912_608',
    f912_912: 'f912_912',
    m20_20: 'm20_20',
    m385_385: 'm385_385',
    m385_385_70_sharpen: 'm385_385_70_sharpen',
    m400_800: 'm400_800',
    m828_828: 'm828_828',
    w1500: 'w1500',
    w800: 'w800',
    w828_60_sharpen: 'w828_60_sharpen',
  },
  // 참고! 예약 쪽 섬네일 모음: https://oss.navercorp.com/booking/booking-web/issues/797
  booking: {
    f80_80: 'f80_80_60_sharpen',
    f442_442: 'f452_452', // deprecated
    f442_442_70_sharpen: 'f452_452_60_sharpen',
    f332_332_70_sharpen: 'f452_452_60_sharpen',
    f50_blur: 'f50_blur',
    f828_828: 'f980_980', // deprecated
    f828_828_70_sharpen: 'f980_980_60_sharpen',
    m385_385: 'm286',
    m385_385_70_sharpen: 'm286',
    f220_220_70_sharpen: 'f220_220_60_sharpen',
    f510_510_70_sharpen: 'f513_513',
    f1300_600: 'f1167_594',
    f352_440: 'f352_440', // (pup) 리작완 > 세로가 더 긴 리뷰 이미지
    f440_440: 'f440_440', // (pup) 리작완 > 정방형 리뷰 이미지
    f660_440: 'f660_440', // (pup) 리작완 > 가로가 더 긴 리뷰 이미지
    f912_1140: 'f912_1140',
    f912_608: 'f912_608',
    f912_912: 'f912_912',
  },
  contact: {
    f102_102: 'f102_102',
    f60_60: 'f60_60',
  },
  blog: {
    h320_sharpen: 'h320_sharpen',
    f48_48: 'f48_48',
  },
  // 내자산 썸네일 https://oss.navercorp.com/place/mydataXplaceReview_QA/issues/52#issuecomment-8971003
  mymoney: {
    a150_235: 'a150_235',
    f255_100: 'f255_100',
    f60_60: 'f60_60',
    f70_70: 'f70_70',
  },
  video_platform: {
    f120: 'f120', // 미디어 뷰어 인덱스 썸네일
    f352_440: 'f352_440', // 리작완 동영상 세로형 썸네일
    f440_440: 'f440_440', // 리작완 동영상 정방형 썸네일
    f660_440: 'f660_440', // 리작완 동영상 가로형 썸네일
    f912_1140: 'f912_1140', // 엔드 동영상 세로형 썸네일
    f912_608: 'f912_608', // 엔드 동영상 가로형 썸네일
    f912_912: 'f912_912', // 엔드 동영상 정방형 썸네일
    w800: 'w800',
    w828_60_sharpen: 'w828_60_sharpen', // 리뷰엔드 썸네일, 테마리스트 리뷰 썸네일
    f220_220_70_sharpen: 'f220_220_70_sharpen', // 방문탭/방문엔드 리뷰 썸네일
    f442_442_70_sharpen: 'f442_442_70_sharpen', // 리뷰 작성 / 수정 썸네일
    f510_510_70_sharpen: 'f510_510_70_sharpen', // 리뷰탭 리뷰 썸네일
    f50_blur: 'f50_blur',
  },
  pup: {
    b120_60_sharpen: 'b120_60_sharpen',
    b240_60_sharpen: 'b240_60_sharpen',
    b480_60_sharpen: 'b480_60_sharpen',
    f120: 'f120',
    f1300_600: 'f1300_600',
    f220_220_60_sharpen: 'f220_220_60_sharpen',
    f220_220_70_sharpen: 'f220_220_70_sharpen',
    f300_300_60_sharpen: 'f300_300_60_sharpen',
    f352_440: 'f352_440',
    f440_440: 'f440_440',
    f442_442: 'f442_442',
    f442_442_60_sharpen: 'f442_442_60_sharpen',
    f442_442_70_sharpen: 'f442_442_70_sharpen',
    f452_302: 'f452_302',
    f452_302_60_sharpen: 'f452_302_60_sharpen',
    f50_blur: 'f50_blur',
    f510_510_70_sharpen: 'f510_510_70_sharpen',
    f660_440: 'f660_440',
    f80_80: 'f80_80',
    f828_466: 'f828_466',
    f828_828: 'f828_828',
    f828_828_60_sharpen: 'f828_828_60_sharpen',
    f828_828_70_sharpen: 'f828_828_70_sharpen',
    f912_1140: 'f912_1140',
    f912_608: 'f912_608',
    f912_912: 'f912_912',
    ff160_160_60_sharpen: 'ff160_160_60_sharpen',
    m20_20: 'm20_20',
    m385_385: 'm385_385',
    m385_385_60_sharpen: 'm385_385_60_sharpen',
    m385_385_70_sharpen: 'm385_385_70_sharpen',
    m400_800: 'm400_800',
    m828_828: 'm828_828',
    p100_100: 'p100_100',
    w1500: 'w1500',
    w1500_60_sharpen: 'w1500_60_sharpen',
    w500_60_sharpen: 'w500_60_sharpen',
    w800: 'w800',
    w828_60_sharpen: 'w828_60_sharpen',
  },
} as const

export type ThumbnailType = DeepLeaf<typeof THUMBNAIL_TYPES>

export const THUMBNAIL_SERVICES = {
  ldb: 'ldb',
  common: 'common',
  myplace: 'myplace',
  booking: 'booking',
  contact: 'contact',
  blog: 'blog',
  mymoney: 'mymoney',
  video_platform: 'video_platform',
  pup: 'pup',
}

export const RESOLUTION_FILE_SIZE = 10485760

// blueimp/JavaScript-Load-Image의 설정 값
// 이미지를 로드할 때 EXIF 메타데이터의 Orientation 태그를 읽어 해당 값을 사용하여 이미지를 로드합니다.
// Orientation 값이 1인 경우, 이미지는 원래의 방향대로 로드됩니다.
// 이미지가 원본 방향(회전이나 뒤집기 없이)으로 로드됩니다.
// https://github.com/blueimp/JavaScript-Load-Image#orientation
export const ORIGINAL_ORIENTATION = 1

// 0도 회전의 Exif Orientation (Top Left)
// https://wiki.navercorp.com/pages/viewpage.action?spaceKey=ETECH&title=EXIF+Orientation
export const DEFAULT_EXIF_ORIENTATION = 1
